import {colors, tokens, radii} from '@commercial-helios/ui/theme'
import styled, {css} from 'styled-components'

import navigateDownIcon from '@helios/shared/images/icons/navigate-down.svg'
import {text} from '@helios/shared/styles/typography'

export const Wrapper = styled.div`
    display: grid;
    gap: ${tokens.spacing12};
`

export const Item = styled.div`
    background: ${colors.background.muted};
    border-radius: ${radii.arc8};
`

export const ClickableHeader = styled.button`
    width: 100%;
    padding: 0;
    text-align: left;
    cursor: pointer;
    background: none;
    border: none;
    outline: none;
`

interface HeaderProps {
    isActive: boolean
}

export const Header = styled.span<HeaderProps>((props) => {
    const isActive = css`
        transform: rotate(-180deg);
    `

    return css`
        ${text({color: 'default'})}
        position: relative;
        display: grid;
        grid-template-columns: 1fr auto;
        align-items: center;
        gap: ${tokens.spacing20};
        padding: ${tokens.spacing20};

        ::after {
            content: url(${navigateDownIcon});
            transition: ${tokens.smoothInOut};
            transition-property: transform;

            ${props.isActive && isActive}
        }
    `
})

interface ContentWrapperProps {
    $isActive: boolean
    $height: number
}

export const ContentWrapper = styled.div<ContentWrapperProps>((props) => {
    const isActive = css`
        max-height: ${props.$height}px;
    `

    return css`
        max-height: 0;
        overflow: hidden;
        transition: ${tokens.smoothInOut};
        transition-property: max-height;

        ${props.$isActive && isActive}
    `
})

export const Content = styled.div`
    padding: ${tokens.spacing20};
    padding-top: 0;
`
